import { createFileRoute } from "@tanstack/react-router"

import { DecisionsPanel } from "@/pages/DecisionsPanel"

// `?decision=<id>` deep-links a specific decision (e.g. from a corpus synthesis row).
// The panel preselects it; absent, it falls back to the list/empty state.
type DecisionsSearch = { readonly decision?: string }

export const Route = createFileRoute("/portfolio/decisions")({
  component: DecisionsPanel,
  validateSearch: (search: Record<string, unknown>): DecisionsSearch => ({
    decision: typeof search.decision === "string" ? search.decision : undefined,
  }),
})
